module.exports = __webpack_public_path__ + "static/media/card-speed.b20cd198.png";